import * as React from "react";
import * as _ from "lodash";
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IInActiveReasonReportResponse, IInActiveReasonReports } from "@nkr/store/index";
import { Button, FormControl } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import { HeaderWrapper } from './styles';
import { CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import InActiveReasonReportGrid from "./inactive-reason-grid";

interface IOwnProps {

}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getInActiveReasonReport: (startDate: string, endDate: string) => Promise<IInActiveReasonReportResponse>,
    getInActiveResults: (startDate: string, endDate: string) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    report: IInActiveReasonReports,
    startDate: string,
    endDate: string,
    gridApi: GridApi
}

class InActiveReasonReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        report: null,
        startDate: '',
        endDate: '',
        gridApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    componentDidMount = () => {
        //get dates
        let startDate = '';
        let endDate = '';

        if (startDate == '' || endDate == '') {
            startDate = moment().startOf('month').format('YYYY-MM-DD');
            endDate = moment().endOf('month').format('YYYY-MM-DD');
        } else {
            startDate = this.state.startDate;
            endDate = this.state.endDate;
        }

        this.getData(startDate, endDate);
    }

    getData = (startDate: string, endDate: string) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getInActiveReasonReport(startDate, endDate)
                .then((response: IInActiveReasonReportResponse) => {
                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    dateRangeSearch = () => {
        this.getData(this.state.startDate, this.state.endDate);
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }

    handleGetInActiveResults = () => {
        this.props.getInActiveResults(this.state.startDate, this.state.endDate).then((response: any) => {
            downloadFile(response.data, `inactive-reason-results.csv`, 'text/csv');
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'InActive-Reason.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank') {
                    return params.node.rowIndex + 1;
                } else if (colDef.colId == 'xpDate') {
                    return moment(params.value).format('MM/DD/YYYY');
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <HeaderWrapper>
                    <div className='billing-header'>
                        Inactive Reason Report
                    </div>

                    <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='startDate'
                                        value={this.state.startDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>End Date:</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='endDate'
                                        value={this.state.endDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <Button bsStyle='primary' onClick={this.dateRangeSearch}>Search</Button>
                            </div>
                        </div>

                        <div>
                            <Button onClick={this.handleGetInActiveResults}>Export CSV</Button>
                        </div>
                    </div>
                </HeaderWrapper>

                <InActiveReasonReportGrid
                    data={this.state.report}
                    onGridReady={this.onGridReady}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getInActiveReasonReport: (startDate, endDate) => {
            return dispatch(ReportActionCreators.getInActiveReasonReport(startDate, endDate));
        },
        getInActiveResults: (startDate, endDate) => {
            return dispatch(ReportActionCreators.getInActiveResults(startDate, endDate));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(InActiveReasonReport);